// ============================================
// TESTSUBIRIMAGEN.JS — Pagina de prueba temporal del componente SubirImagen
// ============================================
// Acceso via menu: Administracion > Test SubirImagen (solo direccion).
// Se removera cuando SubirImagen este integrado en el admin de productos (Commit B5).

import React, { useState } from 'react';
import SubirImagen from './SubirImagen';

export default function TestSubirImagen() {
  const [imagen, setImagen] = useState(null);

  return (
    <div style={{
      maxWidth: 700,
      margin: '40px auto',
      padding: 30,
      fontFamily: '"Poppins", sans-serif',
    }}>
      <h2 style={{ color: '#265F97', marginBottom: 24 }}>
        Test componente SubirImagen
      </h2>

      <div style={{ marginBottom: 24 }}>
        <SubirImagen
          value={imagen}
          onChange={(url) => setImagen(url)}
          onDelete={() => setImagen(null)}
          folder="beep-os/test"
          label="Imagen de prueba"
          aspectRatio="16:9"
        />
      </div>

      {imagen && (
        <div style={{
          marginTop: 20,
          padding: 14,
          background: '#F3F4F4',
          borderRadius: 8,
          fontSize: 12,
          color: '#3D4248',
          wordBreak: 'break-all',
        }}>
          <strong>URL guardada:</strong><br />
          {imagen}
        </div>
      )}
    </div>
  );
}
